module.exports = __webpack_public_path__ + "img/bebb0c56115e25d53eca912bcf528a4d.jpg";